"use client";

import { ScriptHTMLAttributes } from "react";
import { CookieConsentCategory } from "../types";

type ScriptProps = Omit<ScriptHTMLAttributes<HTMLScriptElement>, "type"> & {
    cookieConsent: CookieConsentCategory;
};

export function CookieConsentScript({ cookieConsent, children, ...props }: ScriptProps) {
    return (
        <script type="text/javascript" data-cookieconsent={cookieConsent} async {...props}>
            {children}
        </script>
    );
}
